<p-dialog [header]="'shareProject.title' | transloco" [modal]="true"
          [(visible)]="visible" (visibleChange)="visibleChange.emit($event)"
          [style]="{ width: '90vw', 'max-width': '420px' }" [dismissableMask]="true">

  <div *ngIf="!isShareable && isOwner" class="share-privacy-step">
    <p>{{ 'shareProject.privateHint' | transloco }}</p>
    <div class="share-privacy-actions">
      <p-button [label]="'shareProject.generateLink' | transloco" severity="danger"
                [loading]="updating" (onClick)="setVisibility(2)" />
      <p-button [label]="'shareProject.makePublic' | transloco" [outlined]="true"
                severity="danger" [loading]="updating" (onClick)="setVisibility(1)" />
    </div>
  </div>

  <div *ngIf="!isShareable && !isOwner" class="share-private-blocked">
    <p>{{ 'shareProject.notShareable' | transloco }}</p>
  </div>

  <div *ngIf="isShareable" class="share-body">
    <div class="share-link-row">
      <span class="share-link">{{ shareUrl }}</span>
      <button type="button" class="share-copy" [class.copied]="copied" (click)="copyLink()"
              [attr.aria-label]="copied ? 'Link copiado' : 'Copiar link'">
        <i class="pi" [class.pi-copy]="!copied" [class.pi-check]="copied"></i>
      </button>
    </div>
    <div class="share-socials">
      <button type="button" class="social-btn facebook" (click)="shareOnFacebook()">
        <i class="pi pi-facebook"></i>
        <span>Facebook</span>
      </button>
      <button type="button" class="social-btn whatsapp" (click)="shareOnWhatsapp()">
        <i class="pi pi-whatsapp"></i>
        <span>WhatsApp</span>
      </button>
      <button type="button" class="social-btn threads" (click)="shareOnThreads()">
        <i class="pi pi-at"></i>
        <span>Threads</span>
      </button>
      <button type="button" class="social-btn twitter" (click)="shareOnTwitter()">
        <i class="pi pi-twitter"></i>
        <span>Twitter</span>
      </button>
    </div>
    <div class="share-qr" *ngIf="qrCodeDataUrl">
      <img [src]="qrCodeDataUrl" alt="QR Code" />
      <span>{{ 'shareProject.scanHint' | transloco }}</span>
    </div>
  </div>
</p-dialog>
